<!-- <div class="checkbox-container">
    <input type="checkbox" id="checkbox" name="checkbox" [(ngModel)]="checked" />
    <label for="checkbox" [hidden]="!label" style="padding-left: 5px;">{{label}}</label>
</div> -->
<div class="form-input-container" [style]="style">

    @if (readonly) {
        <div style="width:100%; display:flex; align-items: center; justify-content: start; gap:10px;">
            <div style="display:flex;">
                <input type="checkbox" id="{{myId}}" style="width:25px; height:25px;" [disabled]="true" [(ngModel)]="boundValue" />
            </div>
            <div style="display:flex; text-align: left; min-width:150px;">
                <div class="label" style="vertical-align: middle; ">{{label}}</div>
            </div>
        </div>
    }
    
    <div [style]="style" class="">
    @if (!readonly) {
        <div class="checkbox-container form-input" style="display:flex; align-items: center;" [class.is-invalid]="!isValid" id="{{myId}}_container">
            <input type="checkbox" id="{{myId}}" [(ngModel)]="boundValue" (change)="handle_change($event)" />
            <label style="padding-right: 5px; padding-left: 10px; padding-top: 5px; font-family: Booton; font-weight: 400; font-size: 12px; color: var(--green-800);">{{label}}</label>
            <!-- <div style="position:absolute; left:0px; top:0px;">
            @if (helpText != '') {
                <div class="helpOverlay" (mouseover)="showHelp($event);">?</div>
            }
            </div> -->
            <!-- @if (helpVisible && helpText != '') {
            <div id="{{myId}}_h" (mouseout)="hideHelp($event)" (click)="$event.stopPropagation()" class="contextHelpBox" style="left:0px; top:0px; min-width:200px;">
                {{helpText}}
            </div>
            } -->
        </div>
        <span class="validation-msg" style="bottom:-.8em;" [hidden]="!required">{{validationMsg}}</span>
    }
    </div>

</div>